import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router";
import { type AccessRole, ROLE_LEVEL, useAuth } from "@/lib/hooks/useAuth";

interface Props {
  children: ReactNode;
  minRole?: AccessRole;
}

/**
 * Route guard — redirects to /login if not authenticated.
 * Optionally enforces a minimum access role.
 */
export function RequireAuth({ children, minRole }: Props) {
  const { user, loading, accessRole } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50">
        <p className="text-sm text-slate-500">Sessie controleren…</p>
      </div>
    );
  }

  if (!user) {
    return <Navigate to={`/login?redirect=${encodeURIComponent(location.pathname)}`} replace />;
  }

  if (minRole && ROLE_LEVEL[accessRole] < ROLE_LEVEL[minRole]) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-50">
        <p className="text-sm text-red-600">Onvoldoende rechten voor deze pagina.</p>
      </div>
    );
  }

  return <>{children}</>;
}
